export default __webpack_public_path__ + "static/media/userGray.6cf8997a.svg";